import loadable from '@loadable/component';
import { LoadableFallback } from '../../../../../../../packages/LoadableHelpers';

export const UndergroundMapContainerLoadable = loadable(() => import('./UndergroundMapContainer'), {
  resolveComponent: ({ UndergroundMapContainer }) => UndergroundMapContainer,
  fallback: <LoadableFallback spinnerSize={42} />,
  ssr: false,
});
